module.exports = __webpack_public_path__ + "static/media/left-star-icon.5e9b0133.svg";